import { render } from "./PrivacyPolicy.vue?vue&type=template&id=0b8c7d80"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=ts"
script.render = render

export default script